export const listActions = <const>{
	UPDATE_DELBA_PP_ROWS: 'updateDelbaPpRows',
};
